module.exports = __webpack_public_path__ + "static/media/avalon.f48a7555.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avalon.png
// module id = 204
// module chunks = 0